/**
 * Narcotic Control Form Vuex module for Portal Application
 * Controls the data and actions for narctic forms
 * 
 * @module NarcoticControlForm
 * @see
 * @author Bailey Kulman (Fresche Solutions)
 * @date July 2023
 */

import portalapi from "@services/portalapi";
import { resetStateData } from "@/utils/vuexStoreUtils";
import { getField, updateField } from "vuex-map-fields";

const DEFAULT_NARCOTIC_FORM = {
    header: {},
    details: [],
};

const DEFAULT_STATE = {
    narcoticForm: { ...DEFAULT_NARCOTIC_FORM },
    narcoticControlForms: [],
    formStatusCodes: [],
};

const state = structuredClone(DEFAULT_STATE);

const getters = {
    getField, // for vuex-map-fields

    getNarcoticForm(st) {
        return st.narcoticForm;
    },

    getNarcoticFormsPage(st) {
        return st.narcoticControlForms;
    },

    getFormStatusCodes(st) {
        return st.formStatusCodes;
    },
};

const mutations = {
    updateField, // for vuex-map-fields

    async clearStateData(st) {
        st = resetStateData(st, DEFAULT_STATE);
    },
    
    setNarcoticForm(st, payload) {
        st.narcoticForm = payload;
    },

    setNarcoticFormsPage(st, payload) {
        st.narcoticControlForms = payload;
    },

    setFormStatusCodes(st, payload) {
        st.formStatusCodes = payload;
    },
};

const actions = {
    // Get All Narcotic Forms
    async fetchNarcoticFormsPage({ commit }, payload)
    {
        const requestPayload = {
            page: (payload && payload.page ? payload.page : 1),
            itemsPerPage: (payload && payload.itemsPerPage ? payload.itemsPerPage : 20),
            filters: (payload && payload.filters ? payload.filters : []),
            sortBy: (payload && payload.sortBy ? payload.sortBy : {column: "formStatus", state: "asc"}),
        };

        const response = await portalapi.moduleNarcoticControlForms.getNarcoticFormsPage(requestPayload);

        if (response && response.status === vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
            commit("setNarcoticFormsPage", response.data);     
        }
    },


    // Get and save Narcotic Control Form into VueX store
    async fetchNarcoticForm({ commit }, formNum) 
    {
        commit("setNarcoticForm", { ...DEFAULT_NARCOTIC_FORM });   

        var form = await actions.retrieveNarcoticForm({ commit }, formNum);

        commit("setNarcoticForm", form);  
    },


    // Get and return Narcotic Control Form
    async retrieveNarcoticForm({ commit }, formNum) 
    {
        let response = await portalapi.moduleNarcoticControlForms.getNarcoticControlForm(formNum);

        // Check if the form was found
        if (response && response.status === vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
            response = response.data;
            response.formFound = true;
        } else {
            response = {
                formFound: false,
            };
        }

        return response;        
    },


    // Submit Narcotic Control Form to D365
    async submitNarcoticForm({ commit }, payload) 
    {
        const result = await portalapi.moduleNarcoticControlForms.submitNcfToD365(payload);

        return (result && result.status ? result : false);
    },


    // Submit Narcotic Control Form dispute to D365
    async submitFormDispute({commit}, payload) 
    {
        const result = await portalapi.moduleNarcoticControlForms.submitDisputeToD365(payload);

        return (result && result.status ? result : false);
    },


    // Get Status Codes
    async fetchStatusCodes(context) 
    {
        var commit = context.commit;

        if (context.state.formStatusCodes.length == 0) {
            const response = await portalapi.moduleNarcoticControlForms.getNarcoticFormStatusCodes();

            if (response && response.status === vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
                commit("setFormStatusCodes", response.data);
            }
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};